(() => {
	"use strict";

	if (customElements.get("contact-form-message")) {
		return;
	}

	customElements.define(
		"contact-form-message",
		class ContactFormMessage extends HTMLElement {
			connectedCallback() {
				this.hidePopups();
				this.closeFormMessage();

				if (this.hasAttribute("data-auto-hide")) {
					// Auto-hide mode: the alert disappears after 20s, so we do not
					// move focus to it (that would leave focus on a hidden element
					// when it closes). The role="alert" live region handles the
					// screen reader announcement.
					this.autoHideMessage();
				} else {
					// Keep-open mode: focus the alert so keyboard users are notified,
					// and it stays visible until the visitor dismisses it.
					this.focusMessage();
				}
			}

			focusMessage() {
				// Move focus to the alert (the role="alert" element) so keyboard
				// and screen reader users are notified. Server-rendered live
				// regions are not reliably announced on page load, so focusing is
				// required. Focusing the alert (not the region wrapper) ensures the
				// message text itself is announced.
				const alert = this.querySelector('[role="alert"]');

				if (!alert) {
					return;
				}

				window.requestAnimationFrame(() => {
					alert.focus();
					// The theme suppresses outlines on [tabindex="-1"]:focus, and
					// programmatic focus on page load does not reliably paint the
					// :focus state. Toggle an explicit class so the focus indicator
					// renders regardless.
					alert.classList.add("is-focused");
				});

				alert.addEventListener(
					"blur",
					() => {
						alert.classList.remove("is-focused");
					},
					{ once: true }
				);
			}

			hidePopups() {
				document.body.classList.add("notification-visible");
			}

			showPopups() {
				document.body.classList.remove("notification-visible");
			}

			closeFormMessage() {
				const closeButton = this.querySelector("[data-form-message-close]");

				if (!closeButton) {
					return;
				}

				closeButton.addEventListener("click", this.closeMessage.bind(this));
			}

			closeMessage(event) {
				event.preventDefault();
				this.classList.add("hide-down");
				this.showPopups();
			}

      autoHideMessage() {
				setTimeout(() => {
					this.classList.add("hide-down");
					this.showPopups();
				}, 2e4);
			}
		}
	);
})();
